import { SummitFormattedText } from '@summit/models';
import { Dayjs } from 'dayjs';
import { EboObject } from '../../base-classes/ebo-object';
import { Employee } from '../../employee/employee';
import { Route } from '../../route/route';
import { Dispute } from './dispute';
import { MissingRevenue } from './missing-revenue';

export class DisputeReconcile extends EboObject {
  disputeId: string;
  dispute: Dispute;
  reconcileId: string;
  reconcile: MissingRevenue;

  constructor(jsonData?: Partial<DisputeReconcile>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.dispute) this.dispute = new Dispute(jsonData.dispute);
      if (jsonData.reconcile) this.reconcile = new MissingRevenue(jsonData.reconcile);
    }
  }

  public get eventDate(): Dayjs {
    return this.reconcile.eventDate;
  }
  public get route(): Route {
    return this.reconcile.route;
  }
  public get payTypeSummary(): string {
    return this.reconcile.payTypeSummary;
  }
  public get origNum(): number {
    return this.reconcile.origNum;
  }
  public get origAbbr(): string {
    return this.reconcile.origAbbr;
  }
  public get destNum(): number {
    return this.reconcile.destNum;
  }
  public get destAbbr(): string {
    return this.reconcile.destAbbr;
  }

  public get employee(): Employee {
    return this.reconcile.employee;
  }

  public get reconcileSummary(): SummitFormattedText {
    const response = new SummitFormattedText();
    if (this.reconcile) {
      const flagSummary = this.reconcile.flagSummary;
      if (!flagSummary.isEmpty()) {
        response.AddLine('Flag:', ['font-bold']);
        response.AddText(flagSummary);
      }
      const commentSummary = this.reconcile.commentSummaryFormatted;
      if (!commentSummary.isEmpty()) {
        response.AddLine('Comment:', ['font-bold']);
        response.AddText(commentSummary);
      }
    }
    return response;
  }

  // Dispute-side getters
  public get disputeEventDate(): Dayjs {
    return this.dispute?.eventDate;
  }

  public get disputeStatus(): number {
    return this.dispute?.status;
  }

  public get disputeAmount(): number {
    return this.dispute?.amount;
  }

  public get disputeDescription(): string {
    return this.dispute?.description;
  }

  public get disputeCompany(): string {
    return this.dispute?.company?.name;
  }

  public get disputeHub(): string {
    return this.dispute?.hub?.name;
  }

  public get disputeBeginDateTime(): Dayjs {
    return this.dispute?.beginDateTime;
  }

  public get disputeEndDateTime(): Dayjs {
    return this.dispute?.endDateTime;
  }

  public get disputeVendorReferenceNumber(): string {
    return this.dispute?.vendorReferenceNumber;
  }

  public get disputeUpdateSummary(): string {
    return this.dispute?.updateSummary;
  }

  public get disputeFileSummary(): SummitFormattedText {
    return this.dispute?.fileSummary;
  }
}
